import React, { useState, useEffect } from "react";

import { useTheme } from "@mui/material/styles";
import { Box, CircularProgress } from "@mui/material";

import { ReactComponent as ToggleOnIcon } from "assets/images/icons/Toggle-On.svg";
import { ReactComponent as ToggleOffIcon } from "assets/images/icons/Toggle-Off.svg";

import CollapseCard from "components/Collapse";
import TwoColumnContainer from "components/Container/TwoColumnContainer";

const valueWrapSx = {
  minHeight: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
};

const AutoProvisionPanel = ({
  loading,
  viewerPermissions,
  proxyAutoProvisionData,
  handleDataChanged,
  dataCancelFlag,
  setDataCancelFlag,
}) => {
  const theme = useTheme();

  const [enabled, setEnabled] = useState(!!proxyAutoProvisionData?.enable);

  useEffect(() => {
    setEnabled(!!proxyAutoProvisionData?.enable);
  }, [proxyAutoProvisionData]);

  useEffect(() => {
    if (dataCancelFlag?.proxyAutoProvision) {
      setEnabled(!!proxyAutoProvisionData?.enable);
      setDataCancelFlag((prev) => ({
        ...prev,
        proxyAutoProvision: false,
      }));
    }
  }, [dataCancelFlag?.proxyAutoProvision, proxyAutoProvisionData]);

  const handleToggle = () => {
    if (viewerPermissions) return;

    const nextEnabled = !enabled;
    setEnabled(nextEnabled);

    handleDataChanged({
      data: {
        "proxy.autoProvision": {
          enable: nextEnabled,
        },
      },
    });
  };

  return (
    <CollapseCard title="Auto Provision" minWidth="550px">
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      ) : (
        <TwoColumnContainer containerAlignItems="center" label="Enable">
          <Box
            sx={{
              ...valueWrapSx,
              cursor: viewerPermissions ? "not-allowed" : "pointer",
              opacity: viewerPermissions ? 0.6 : 1,
            }}
            onClick={handleToggle}
          >
            {enabled ? <ToggleOnIcon /> : <ToggleOffIcon />}
          </Box>
        </TwoColumnContainer>
      )}
    </CollapseCard>
  );
};

export default AutoProvisionPanel;
